import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ImagePeviewModal',
  props: {
    showImg: {
      type: String,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }

const __returned__ = { emits, props, close, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})